import { useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import { useAuthStore } from "../../store/auth/authStore";
import TripsLogo from "../../assets/images/trips-logo.svg";
import UserAvatar from "../../assets/images/user-avatar.png";
import { formatNumberAsCurrency } from "../../utils/helpers";
import { HamburgerMenu } from "@solar-icons/react";
import {
  HeaderContainer,
  TopRowLogo,
  SignInButton,
  SignInAvatar,
  ProfileWrapper,
  ProfilePill,
  ProfileAvatar,
  ProfileBalance,
  DropdownHeader,
  DropdownName,
  DropdownEmail,
  DropdownMenuItem,
  LogoutButton,
  ProfileDropdownGlobalStyle,
} from "./styles";
import AuthModals from "../Auth/AuthModals";

const MainHeader = () => {
  const navigate = useNavigate();
  const { isLoggedIn, setAuthModal, logout, b2CUser } =
    useAuthStore();

  const profileMenu = {
    items: [
      {
        key: "header",
        label: (
          <DropdownHeader>
            <ProfileAvatar style={{ border: "none", margin: 0 }}>
              {b2CUser?.ProfileImage ? (
                <img
                  src={b2CUser.ProfileImage}
                  alt="Profile"
                  style={{ width: "100%", height: "100%" }}
                />
              ) : (
                <img
                  src={UserAvatar}
                  alt="avatar"
                  style={{ width: "100%", height: "100%" }}
                />
              )}
            </ProfileAvatar>
            <div>
              <DropdownName>{b2CUser?.FullName || "User"}</DropdownName>
              <DropdownEmail>{b2CUser?.Email || "N/A"}</DropdownEmail>
            </div>
          </DropdownHeader>
        ),
      },
      {
        key: "account",
        label: <DropdownMenuItem>Account</DropdownMenuItem>,
      },
      {
        key: "trips",
        label: <DropdownMenuItem>My trips</DropdownMenuItem>,
      },
      // {
      //   key: 'help',
      //   label: <DropdownMenuItem>Help</DropdownMenuItem>,
      // },
      {
        type: "divider" as const,
      },
      {
        key: "logout",
        label: <DropdownMenuItem onClick={logout}>Log out</DropdownMenuItem>,
      },
    ],
  };

  return (
    <>
      <ProfileDropdownGlobalStyle />
      <HeaderContainer>
        <TopRowLogo src={TripsLogo} alt="TRIPS" onClick={() => navigate("/")} />
        {!isLoggedIn ? (
          <SignInButton onClick={() => setAuthModal(true)}>
            <SignInAvatar>
              <img
                src={UserAvatar}
                alt="avatar"
                style={{ width: "100%", height: "100%" }}
              />
            </SignInAvatar>
            Sign in
          </SignInButton>
        ) : (
          <ProfileWrapper>
            <Dropdown
              menu={profileMenu}
              trigger={["click"]}
              placement="bottomRight"
              overlayClassName="profile-header-dropdown"
              overlayStyle={{ width: "280px" }}>
              <ProfilePill>
                <ProfileAvatar>
                  {b2CUser?.ProfileImage ? (
                    <img
                      src={b2CUser.ProfileImage}
                      alt="Profile"
                      style={{ width: "100%", height: "100%" }}
                    />
                  ) : (
                    <img
                      src={UserAvatar}
                      alt="avatar"
                      style={{ width: "100%", height: "100%" }}
                    />
                  )}
                </ProfileAvatar>
                <ProfileBalance>
                  {formatNumberAsCurrency(b2CUser?.WalletBalance || 0, "KES")}
                </ProfileBalance>
                <HamburgerMenu size={24} color="#111827" />
              </ProfilePill>
            </Dropdown>
          </ProfileWrapper>
        )}
      </HeaderContainer>
      <AuthModals />
    </>
  );
};

export default MainHeader;
